import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { submitArea, hideVoteAreaModal } from '../../actions/voteAreaActions';
import { trackAddressNotDeliverable } from '../../actions/tracking/location';
import VoteAreaModal from '../../components/VoteAreaModal';
import i18n from '../../utils/i18n';

// eslint-disable-next-line react/no-deprecated
export class VoteAreaContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isSubmitted: props.isSubmitted,
      errorMessage: props.errorMessage,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { isSubmitted, errorMessage } = this.state;

    if (nextProps.isSubmitted && nextProps.isSubmitted !== isSubmitted) {
      this.setState({
        isSubmitted: nextProps.isSubmitted,
        errorMessage: null,
      });
    } else if (nextProps.errorMessage && nextProps.errorMessage !== errorMessage) {
      this.setState({
        errorMessage: nextProps.errorMessage,
      });
    }
    if (nextProps.isOpen && !this.props.isOpen) {
      this.fireEvent();
    }
  }

  onSubmit = (email) => {
    const { postCode, lat, lng } = this.props;
    const { isSubmitted } = this.state;

    if (!isSubmitted) {
      if (email === '') {
        this.setState({
          errorMessage: i18n.gettext('locationSearch.voteArea.error.blankEmail'),
        });
      } else {
        const postdata = {
          post_code: postCode,
          // yes, the endpoint is expecting these the wrong way around…
          coordinates: [lng, lat],
          email,
        };

        this.props.submitArea(postdata);
      }
    }
  };

  fireEvent = () => {
    const { page, postCode, formattedAddress, lat, lng } = this.props;

    this.props.trackAddressNotDeliverable({
      action: 'Viewed',
      sourceView: page,
      searchString: formattedAddress || postCode,
      postCode,
      lat,
      lng,
    });
  };

  render() {
    const { isOpen, onClose } = this.props;
    const { errorMessage, isSubmitted } = this.state;

    return (
      <VoteAreaModal
        isOpen={isOpen}
        onClose={onClose}
        onSubmit={this.onSubmit}
        errorMessage={errorMessage}
        isSubmitted={isSubmitted}
        heading={i18n.gettext('locationSearch.voteArea.heading')}
        inputLabel={i18n.gettext('locationSearch.voteArea.label')}
        inputPlaceholder={i18n.gettext('locationSearch.voteArea.email.placeholder')}
        confirmationMessage={i18n.gettext('locationSearch.voteArea.confirmationMessage')}
        genericErrorMessage={i18n.gettext('locationSearch.voteArea.error.email')}
      />
    );
  }
}

VoteAreaContainer.propTypes = {
  isSubmitted: PropTypes.bool,
  errorMessage: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  page: PropTypes.string,
  postCode: PropTypes.string,
  formattedAddress: PropTypes.string,
  lat: PropTypes.number,
  lng: PropTypes.number,
  trackAddressNotDeliverable: PropTypes.func.isRequired,
  submitArea: PropTypes.func.isRequired,
};

VoteAreaContainer.defaultProps = {
  isSubmitted: false,
  errorMessage: undefined,
  page: '',
  postCode: undefined,
  formattedAddress: undefined,
  lat: undefined,
  lng: undefined,
};

const mapStateToProps = (state) => {
  const {
    post_code: postCode,
    formatted_address: formattedAddress,
    lat,
    lng,
    showVoteAreaModal: isOpen,
  } = state.location.search;
  const { submitted: isSubmitted, error } = state.voteArea;
  const errorMessage = error && error.message;

  return {
    isOpen,
    postCode,
    formattedAddress,
    lat,
    lng,
    isSubmitted,
    errorMessage,
  };
};

const mapDispatchToProps = (dispatch) => ({
  submitArea: (areaData) => dispatch(submitArea(areaData)),
  trackAddressNotDeliverable: (options) => dispatch(trackAddressNotDeliverable(options)),
  onClose: () => dispatch(hideVoteAreaModal()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(VoteAreaContainer);
